<template>
  <div id="framework-content">
    <!-- 当前位置 -->
    <div class="content-position">我的钱包
      <!-- 计费规则 -->
      <span class="charging-rule">
        <span @mouseover="ruleShow" @mouseout="ruleHide">
          <!-- <img src="../../assets/images/personal/charging.png"> -->
          计费规则
        </span>
        <transition name="fade">
          <div class="charging-rule-box" v-show="chargingRuleBox">
            <p><b>计费规则</b></p>
            <p>1.&nbsp;url快照取证:&nbsp;&nbsp;{{packageRules['30001']}}元/次</p>
            <p>2.&nbsp;录屏取证:&nbsp;&nbsp;时长收费&nbsp;&nbsp;{{packageRules['30002']}}元/分钟</p>
                    <p>3.&nbsp;如音视频存证无法识别其时长，则50元/次</p>
          </div>
        </transition>
      </span>
    </div>
    <!-- 内容区域 -->
    <div class="content-main">

      <!-- 我的账户 -->
      <div class="my-count common-item">
        <div class="my-count-tab common-item-title">我的账户</div>
        <div class="remain-sum-box">
          <span class="remain-sum-money"><b>{{balance}}</b></span>
          <span class="remain-sum-pay" @click="goOnlinePayment">充&nbsp;值</span>
        </div>
      </div>

      <!-- 套餐服务 -->
      <div class="bunding-service common-item" style="margin-bottom: 30px;">
        <div class="bunding-service-tab common-item-title">套餐服务</div>
        <div class="bunding-service-box" v-if="!hasService">
          <span v-for="package in packages">已{{package.productName}}<b>&nbsp;<i @click="goMyEvidence">{{package.usedValue}}</i>&nbsp;</b>{{package.unit}}，还有<b>&nbsp;<i @click="goOnlinePayment">{{package.configValue-package.usedValue}}</i>&nbsp;</b>{{package.unit}}可以使用</span>
        </div>
        <div class="no_service" v-else>您还没有套餐服务！</div>
      </div>

      <!-- 消费明细 -->
      <div class="consume-detail">
        <div class="consume-detail-title">消费记录</div>
        <table class="table">
          <tr>
            <th style="width: 17%">标题</th>
            <th style="width: 17%">类型</th>
            <th style="width: 17%">存证时间</th>
            <th style="width: 17%">花费</th>
            <th style="width: 32%">URL</th>
          </tr>
          <tr v-for="item in datas.data">
            <td>{{item.evidenceName}}</td>
            <!-- <td>{{item.sourceTitle}}</td> -->
            <td>{{item.evidenceTypeDesc}}</td>
            <td>{{item.evidenceFinishTime}}</td>
            <td>{{item.expenceDesc}}</td>
            <td class="url" @click="openPage(item.sourceUrl)">{{item.sourceUrl}}</td>
          </tr>
        </table>
        <div class="no-data" v-if="!hasData">
          <img src="../../assets/images/personal/nodata.png">
          <p>&nbsp;&nbsp;&nbsp;&nbsp;您目前还没有数据...</p>
        </div>
        <paging-personal  :pageInfo="pageInfo" :isAsync="true" style="margin-top: 15px;"></paging-personal>
      </div>

    </div>




		<!-- 支付弹窗 -->
		<transition name="fade">
    <div class="pay-box" v-if="isPrepaidNow">
		    <div class="bgshade-box"></div>
		  	<div class="con-box">
            <h4>充值</h4>
            <form action="" method="">
                <p class="form-item money-select">
                    <label @click="moneySelect" class="selectActive"></label>
                    <span>10元</span>
                    <input type="text" name="" value="10">
                </p>
                <p class="form-item money-select">
                    <label @click="moneySelect"></label>
                    <span>50元</span>
                    <input type="text" name="" value="50">
                </p>
                <p class="form-item money-select">
                    <label @click="moneySelect"></label>
                    <span>100元</span>
                    <input type="text" name="" value="100">
                </p>
                <p class="form-item money-select">
                    <label id="other" @click="moneySelect"></label>
                    <span>其它金额</span>
                    <input type="text" name="" value="other">
                </p>
                <p class="form-item money-text">
                    <input id="payInput" type="text" name="" placeholder="最低充值金额十元" @input="inputPay" v-model="sum" @focus="otherSelect">
                </p>
                <!--<p class="form-item money-sum">共计:￥<b>{{sum<10?10:sum}}</b></p>-->
                <p class="form-item money-sum">共计:￥<b>{{sum==''?0:sum}}</b></p>
                <p class="form-item money-pay">
                    <span @click="goPay">支付宝支付</span>
                </p>
            </form>
            <!--<div style="border-bottom: 1px solid #c1c1c1;float:left; width:100%;"></div>-->
            <div class="closePopup" @click="closePopup">x</div>
		  	</div>
		</div>
		</transition>
		<!-- 是否支付成功弹窗 -->
		<transition name="fade">
        <div class="pay-box" v-if="isPayStatus">
            <div class="bgshade-box"></div>
            <div class="con-box">
                <h4>充值</h4>
                <form action="" method="">
                    <p class="form-item money-pay pay-status">
                      <span @click="payLast">完成支付</span>
                    </p>
                    <p class="form-item money-pay pay-status">
                      <span @click="payLast">支付失败</span>
                    </p>
                    <p class="form-item customer-service">联系客服：010-84770602</p>
                </form>
            </div>
        </div>
		</transition>
  </div>
</div>
</template>

<script>
  import PagingPersonal from '@/components/common/PagingPersonal'
	// import Loading from '@/components/common/Loading';
  import Accounting from 'accounting';
	import CONST from '@/lib/const';

	export default {
		name: 'accountBalance',
    components:{PagingPersonal},
    mounted (){
      let path = this.$router.currentRoute.path;
      this.$emit('childChange', path.substring(path.lastIndexOf('/')));
      this.dataRequest();
      this.getProductInfoList();
    },
		data () {
			return {
				chargingRuleBox: false,
				isPrepaidNow:false,
				sum:10,
        pageNum:1,
				isPay:false,
				paySatus:true,  //支付是否成功状态
				isPayStatus:false,
        hasService:false,
				balance: '',
        packages: [
          {
            productCode: 30001,
            productName: CONST.PACKAGE_CONFIG['30001'],
            usedValue: 0,
            configValue: 0,
            unit:'条'
          },{
            productCode: 30002,
            productName: CONST.PACKAGE_CONFIG['30002'],
            usedValue: 0,
            configValue: 0,
            unit:'分钟'
          }
        ],
        datas: {
				    data:[],
            page: {}
        },
        hasData: true,
        user: this.$getLocalStorage('IP360', 'user'),
        packageRules:{
          '30001': 0,
          '30002': 0
        },
        isAsync: true,
        showNullData: false,
        pageInfo:{
          pageNumber:1,
          pageSize:10
        }
      }
		},
		methods: {
			//计费规则显示控制
      ruleShow () {
        this.chargingRuleBox = true;
      },
      ruleHide () {
        this.chargingRuleBox = false;
      },
      goOnlinePayment () {
        this.$router.push('account_balance/online_payment')
      },
			//支付弹窗
			prepaidNow () {
				this.isPrepaidNow = true;
			},
			moneySelect (e) {
				let oTarget = $(e.target);
				let val = oTarget.next().next('input').val();
				if(val == 'other'){
          this.sum = '';
          $('#payInput').focus();
        }else{
          this.sum = oTarget.next().next('input').val();
        }

				oTarget.parent().siblings('.money-select').children('label').removeClass('selectActive');
				oTarget.addClass('selectActive');
			},
      otherSelect(){
        $('.money-select').children('label').removeClass('selectActive');
        $('#other').addClass('selectActive');
      },
      goMyEvidence () {
        this.$router.push('/personal_center/my_evidences')
      },
      getProductInfoList(){ //返回套餐详情
        this.$axios.request({
          url: '/webapi/personal/getProductInfoList',
          method: 'get',
          params: {
            token: this.user.token
          }
        }).then(response => {
            // console.log('product info list: ', response.data.datas.productList);
            if(response.data.code == 200){
              let list = response.data.datas.productList;
              list.forEach(item => {
                  this.packageRules[item.productCode] = parseFloat(item.productPrice / 100).toFixed(2);
              })
            }
        });
      },
      dataRequest(){
        this.$store.commit('showLoadingPersonal',true);

        let query = this.$router.history.current.query
        let pageNo = query.pageNumber ? query.pageNumber : 1;
        let pageSize = query.pageSize ? query.pageSize : 10;

        this.$axios.request({
          url: '/webapi/personal/getTaskListByPage',
          method: 'get',
          params: {
            operatorId: this.user.id,
            pageNo,
            pageSize,
            searchType: 3,
            token: this.user.token,
            timestamp:new Date().getTime()
          }
        }).then((response) => {
          this.$store.commit('showLoadingPersonal',false);
          let result = response.data;
          // console.log('results: ', result);
          if(result.code == 200){

            let pageInfo = {};
            pageInfo.pageNumber = result.datas.result.pageNumber;
            pageInfo.pageSize = result.datas.result.pageSize;
            pageInfo.totalPage = result.datas.result.totalPage;
            pageInfo.totalRow = result.datas.result.totalRow;
            this.pageInfo = pageInfo;

            this.balance = Accounting.formatMoney(parseFloat(result.datas.balance/100).toFixed(2),'￥');
            let packages = result.datas.totalProductUserValue;
            if(packages.length > 0){
              packages.forEach((item)=>{
                if(item.productCode == '30001'){
                  item.unit = '条';
                  this.packages[0] = item;
                }else if(item.productCode == '30002'){
                  item.unit = '分钟';
                  this.packages[1] = item;
                }
              });

              //是否有服务套餐
              let saveServiceValue = [];
              this.packages.forEach((item)=>{
                saveServiceValue.push(item.usedValue,item.configValue);
              });
              this.hasService = saveServiceValue.every((item)=>{
                return item == 0;
              });
            }
            if(result.datas.result.list.length > 0 ){
              this.hasData = true;
            } else {
              this.hasData = false;
            }
            result.datas.result.list.forEach(function(item){
              item.sourceTitle = item.sourceTitle || "知识产权产权";
              item.evidenceTypeDesc = CONST.EVIDENCE_TYPE[item.evidenceType-1];
              item.expenceDesc = item.company == '分'
                                      ? Accounting.formatMoney(item.value/100,'￥')
                                      : item.value + item.company;

//              item.exp  = false;
//              item.statusDesc = statusDesc[item.saveStatus];
//              result.payStatus = 3;
//              item.extralDesc = "";
//              if(result.payStatus == 3){
//                result.extralDesc += "（退款成功）";
//              }else if(result.payStatus == 4){
//                result.extralDesc += "（退款失败）";
//              }

            });
            this.datas.data = result.datas.result.list;
          }
        });
      },
			inputPay (e) {
				this.sum = parseFloat(this.sum);
				let reg = /^\d+$/;
				if(!reg.test(this.sum)){
                this.sum = 0;
            }
			},
			goPay () {
				// let reg = /^([1-9][\d]{0,7}|0)(\.[\d]{1,2})?$/;
				if(this.sum<10){
          this.$store.dispatch('showMsgModal',{
            autoClose:false,
            info:'最低充值金额十元'
          });
          return;
        } else if(this.sum>10000000){
          this.$store.dispatch('showMsgModal',{
            autoClose:false,
            info:'充值金额不能大于1000万'
          });
          return;
        } else {
          this.isPay = true;
        }
				if(this.isPay){
					/*
						跳转支付
					*/
					this.openPostWindow(GlobalConfig.webApiServer + '/webapi/webPay/alipayapi?',
            this.sum,
//            0.01,
            this.user.id,
            this.user.token,
            101
          );
					this.isPrepaidNow = false;
					this.isPayStatus = true;
				}
			},
      openPostWindow (url, money,userId, token, type) {
        let newWin = window.open();
        let formStr = '';
        //设置样式为隐藏，打开新标签再跳转页面前，如果有可现实的表单选项，用户会看到表单内容数据
        formStr = '<form style="visibility:hidden;" method="POST" action="' + url + '">' +
          '<input type="hidden" name="money" value="' + money + '" />' +
          '<input type="hidden" name="userId" value="' + userId + '" />' +
          '<input type="hidden" name="token" value="' + token + '" />' +
          '<input type="hidden" name="type" value="' + type + '" />' +
          '</form>';

        newWin.document.body.innerHTML = formStr;
        newWin.document.forms[0].submit();

//          return newWin;
      },
			payLast () {
        this.dataRequest();
        this.isPayStatus = false;
			},
			closePopup () {
				this.isPrepaidNow = false;
				this.sum=10;
			},
      openPage(url){
        window.open(url);
      },
      goto(pageNum){
        this.pageNum = pageNum;
        this.dataRequest();
      },
		},
    watch:{
      '$route' (to, from) {
        this.dataRequest();
      }
    }
	}
</script>

<style scoped>
  .content-position{
    position: relative;
  }
  .common-item{
    height: 70px;
    border-bottom: 1px solid #dbdbdb;
  }
  .common-item .common-item-title{
    float: left;
    height: 69px;
    line-height: 69px;
    width: 60px;

  }
  /*------------------------ 我的账户 style*/
  .remain-sum-box{
    height: 69px;
    position: relative;
    float: left;
    margin-left: 120px;
  }
  .remain-sum-box .remain-sum-money{
    font-size: 22px;
    color: #d93142;
    height: 69px;
    line-height: 69px;
  }
  .remain-sum-box .remain-sum-money b{
    font-weight: normal;
  }
  .remain-sum-box .remain-sum-pay{
    font-size: 14px;
    padding: 6px 26px;
    background-color: #c0404b;
    color: #fff;
    box-sizing: border-box;
    margin-left: 25px;
    position: relative;
    bottom: 4px;
    cursor: pointer;
    line-height: 1;
  }
  .remain-sum-box .remain-sum-pay:hover{
    background: #ce5660;
  }
  /*------------------------ 套餐服务 style*/
  .bunding-service-box{
    height: 69px;
    line-height: 69px;
    font-size: 14px;
    float: left;
    margin-left: 120px;
  }
  .bunding-service-box span{
    color: #7f7f7f;
  }
  .bunding-service-box span:last-child{
    margin-left: 132px;
    color: #7f7f7f;
  }
  .bunding-service-box span b{
    /*font-weight: normal;*/
    color: #c0404b;
    font-size: 16px;
    border-bottom: 1px solid #a12935;
  }
  .bunding-service-box span i{
    font-style: normal;
    cursor: pointer;
  }
  .no_service{
    line-height: 69px;
    color: #7f7f7f;
    float: left;
    margin-left: 120px;
  }
  /*------------------------ 消费明细 style*/
  .consume-detail-title{
    height: 34px;
    line-height: 34px;
  }
  .no_consume{
    text-align: center;
  }
  .no_consume img{
    margin: 30px 0 30px;
  }
  .no_consume p{
    color:#c0c0c0;
    font-size: 18px;
    margin-bottom:80px;
  }
  /*------------------------ 计费规则 style*/
  .charging-rule{
    position: absolute;
    right: 0;
    top: 22px;
    font-size: 14px;
    width: 80px;
    height: 20px;
    cursor:pointer;
  }
  .charging-rule > span{
    display: block;
    width: 90px;
    height: 20px;
    line-height: 18px;
    padding-left: 22px;
    background: url(../../assets/images/personal/charging.png) no-repeat;
    background-position: left 2px;
    color: #333;
  }
  .charging-rule > span:hover{
    color: #c45;
    background: url(../../assets/images/personal/charging_h.png) no-repeat;
    background-position: left 2px;
  }
 /* .charging-rule > span > b {
    float: left;
    margin-left: 5px;
    font-weight: normal;
    line-height: 20px;
  }
  .charging-rule > span > img {
    float: left;
    margin-top: 2px;
  }*/
  .charging-rule .charging-rule-box{
    width: 308px;
    height: 117px;
    box-sizing: border-box;
    padding: 7px 14px 0;
    position: absolute;
    right: 0;
    top: 25px;
    background-color: #f5f5f5;
    color: #3a3a3c;
    z-index: 2;
    line-height: 25px;
  }
  .charging-rule .charging-rule-box p{
    font-size: 14px;
  }
  .charging-rule span:hover .charging-rule-box{
    color: #ada;
  }









	/*------------------------ 选项 style*/
	.remain-sum-tab{
		height: 56px;
		line-height: 56px;
		position: relative;
		font-size: 16px;
	}
	.show-remain-sum .tab{
		border-bottom:1px solid #f1f1f1;
	}
	.show-remain-sum .border0{
		border:0;
	}
	.show-remain-sum .remain-sum-title::before{
		content: '';
		width: 2px;
		height: 16px;
		background-color: #A12935;
		margin: 22px 8px 0 0;
		float: left;
	}
	.show-remain-sum .remain-sum-title{
		margin-right: 30px;
	}








	/*------------------------ animation style*/
	.fade-enter-active, .fade-leave-active {
	  	transition: opacity 0.5s;
	}
	.fade-enter, .fade-leave-active {
	  	transition: .2s;
	 	opacity: 0;
	}
	/*------------------------ popup style*/
  .pay-box{
    position: relative;
  }
  .pay-box,.bgshade-box{
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
	.bgshade-box{
		background-color: rgba(0,0,0,0.5);
		font-size: 16px;
    filter: alpha(opacity=50);
	}
  .con-box{
		width:446px;
		background: #fff;
		border-radius: 5px;
		border:1px solid #Eb828c;
		padding: 16px 17px;
		box-sizing: border-box;
    position: absolute;
    left:50%;
    top:32%;
    margin-left: -223px;
	}
	.con-box h4{
		font-size: 16px;
		color: #a12935;
		height: 36px;
		line-height: 36px;
		font-weight: normal;
		position: relative;
	}
	.con-box .closePopup{
		position: absolute;
		right: 18px;
		top: 20px;
		color: #a12935;
		font-size: 16px;
		cursor: pointer;
	}
	.con-box p.form-item{
		width: 90%;
	}
	.con-box p.money-select{
		width: 33.33%;
		float: left;
		margin:20px 0 0;
		box-sizing: border-box;
		padding-left: 16px;
	}
	.con-box p.money-select input{
		display: none;
		float: left;
	}
	.con-box p.money-select span{
		float: left;
	}
	.con-box p.money-select label{
		float: left;
		width: 14px;
		height: 14px;
		border-radius: 50%;
		border:1px solid #adadad;
		display: flex;
		justify-content: center;
		align-items: center;
		margin:3px 10px 0 10px;
	}
	.con-box p.money-select label.selectActive{;
		border-color: #b71d2a;
		background-image: url(../../assets/personal/select.png);
		background-size: 8px 8px;
		background-repeat: no-repeat;
		background-position: 3px 3px;
	}
	.con-box p.money-text input{
		border:1px solid #c1c1c1;
		height: 42px;
		box-sizing: border-box;
		padding-left: 15px;
		display: block;
		margin-left: 8%;
		width: 92%;
		color: #666;
		float: left;
	}
	.con-box p.money-sum{
		text-align: center;
		color: #b71d2a;
		font-size: 14px;
		margin:20px 0;
		float: left;
	}
	.con-box p.money-sum b{
		font-weight: normal;
	}
	.con-box p.money-pay{
		height: 40px;
	}
	.con-box p.money-pay span{
		float: left;
		display: block;
		width: 92%;
		text-align: center;
		color: #fff;
		margin-left: 8%;
		background-color: #b71d2a;
		height: 40px;
		line-height: 40px;
		border-radius: 6px;
		margin-bottom: 20px;
    cursor:pointer;
	}
	.con-box p.pay-status{
		margin: 30px 0;
	}
	.con-box p.customer-service{
		width: 100%;
		text-align: center;
		font-size: 14px;
		color: #c1c1c1;
		/*border-bottom: 1px solid #c1c1c1;*/
	}
</style>



// WEBPACK FOOTER //
// AccountBalance.vue?0d202a97